// extracted by mini-css-extract-plugin
module.exports = {"top-pick-badge":"top-pick-badge--a8d3d","topPickBadge":"top-pick-badge--a8d3d"};